/**
 * 品牌辞书
 */
import request from '@/api/request'
const brandBookApi = {}

/**
 * 查询列表
 */
brandBookApi.queryBrandBookList = param => {
  return request({
    url: '/function/brand/list',
    method: 'GET',
    params: param
  })
}

/**
 * 新增
 */
brandBookApi.addBrandBook = params => {
  return request({
    url: '/function/brand',
    method: 'POST',
    data: params
  })
}

/**
 * 根据ID查询详情
 */
brandBookApi.queryDetailById = param => {
  return request({
    url: '/function/brand',
    method: 'GET',
    params: param
  })
}

/**
 * 编辑
 */
brandBookApi.updateBrandBook = params => {
  return request({
    url: '/function/brand',
    method: 'PUT',
    data: params
  })
}

/**
 * 删除
 */
brandBookApi.deleteBrandBookById = params => {
  return request({
    url: '/function/brand/remove',
    method: 'POST',
    data: params
  })
}

/**
 * 置顶
 */
brandBookApi.setToTop = param => {
  return request({
    url: '/function/brand/setTopOne',
    method: 'GET',
    params: param
  })
}

// 上传接口
brandBookApi.upLoadData = param => {
  return request({
    url: '/common/upload',
    method: 'POST',
    data: param
  })
}

export default brandBookApi
